import React, { useState } from 'react'
import './EasyTabs.scss'

interface tags {
    label?   : string;
    icon?    : string;
    value    : any;
    disable? : boolean
}

interface tabprops {
    tags        : readonly  tags[]
    setTagFlag  : (item: any) => void
    tagFlag     : any;
    color?      : string
    class_name? : string
    baseClass? : string
}

const EasyTabs: React.FC<tabprops> = (props) => {
    const {
        tags = [],
        setTagFlag,
        tagFlag,
        color,
        class_name = "",
        baseClass = ""
    } = props

    const isActive = (tab: any) => tagFlag === tab.value;

    const getListItemClassName = (tab: any) => `
        ${isActive(tab) ? 'is-active' : ''}
        ${tab?.disable ? 'is-disabled' : ''}
    `;

    const display_tabs = () => (
        <div className={`tabs is-toggle is-toggle-rounded easy-tabs-container ${baseClass}`}>
            <ul className="easy-tabs-list">
                {Array.isArray(tags) && tags.length > 0 && tags.map((tab, index) => (
                    <li
                        key={index}
                        className={getListItemClassName(tab)}
                    >
                        <a
                            className={`easy-tab-link ${class_name} ${color ?? ''}`}
                            onClick={(e) => {
                                e.preventDefault();
                                if (!tab?.disable) {
                                    setTagFlag(tab?.value);
                                }
                            }}
                        >
                            {tab.icon && (
                                <span className="icon is-small">
                                    <i className={`fa fa-${tab.icon}`}></i>
                                </span>
                            )}
                            <span>{tab.label}</span>
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    )

    return display_tabs()
}

export default EasyTabs
